<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <strong>QBR</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="factory">
                                    <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                    <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                       <input :disabled ="disableFactory" type="radio" :name="'coa_FactoryTypeOpt'" v-model="qbrQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                    </div> 
                            </div>
                            <div class="factory">
                                <p>{{$t('QualityInfo_Vue.CustomerName')}}：</p>                                
                                <input style="width: 500px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="qbrQueryParam.customerName">                                                        
                                <Select2 style="width: 500px;" v-if="!disableCusName_input" v-model="qbrQueryParam.vendorId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true }" />
                            </div>
                            <div class="date">
                                <p>&emsp;&emsp;{{$t('QualityInfo_Vue.Period')}}：</p>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="qbrQueryParam.createDateBegin"></date-picker>
                                <span>~</span>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="qbrQueryParam.createDateEnd"></date-picker>
                            </div>
                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="qbrQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success"  @click="qbrExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
        <CCard>
            <CCardBody class="scroll">
                <table class="table ">
                    <thead class="thead-light">
                        <tr>
                            <th class="text-center">{{headers[0]}}</th>
                            <th class="text-center">{{headers[1]}}</th>
                            <th class="text-center">{{headers[2]}}</th>
                            <th class="text-center">{{headers[3]}}</th>
                            <th class="text-center">{{headers[4]}}</th>
                            <th class="text-center">{{headers[5]}}</th>
                            <th class="text-center">{{headers[6]}}</th>
                            <th class="text-center">{{headers[7]}}</th>
                            <th class="text-center">{{headers[8]}}</th>
                            <th class="text-center">{{headers[9]}}</th>
                            <th class="text-center">{{headers[10]}}</th>
                            <th class="text-center">{{headers[11]}}</th>
                            <th class="text-center">{{headers[12]}}</th>
                            <th class="text-center">{{headers[13]}}</th>
                            <th class="text-center">{{headers[14]}}</th>
                            <th class="text-center">{{headers[15]}}</th>
                            <th class="text-center">{{headers[16]}}</th>
                            <th class="text-center">{{headers[17]}}</th>
                            <th class="text-center">{{headers[18]}}</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item , index) in qbrSearchResult" :key="index">                                                
                            <td class="text-center">{{item.factoryName}}</td>                            
                            <td class="text-center">{{item.period}}</td>
                            <td class="text-center">{{item.name1}}</td>
                            <td class="text-center">{{item.matkl + item.wgbez}}</td>
                            <td class="text-center">{{item.zlevel}}</td>
                            <td class="text-center">{{item.zvenCooperationP}}</td>
                            <td class="text-center">{{item.zputin}}</td>
                            <td class="text-center">{{item.zplmIssueP}}</td>
                            <td class="text-center">{{item.zvenIssueP}}</td>
                            <td class="text-center">{{item.zplmTrialP}}</td>
                            <td class="text-center">{{item.ztech}}</td>
                            <td class="text-center">{{item.zsample}}</td>
                            <td class="text-center">{{item.zplatform}}</td>
                            <td class="text-center">{{item.zbadmat}}</td>
                            <td class="text-center">{{item.zontime}}</td>
                            <td class="text-center">{{item.ztiein}}</td>
                            <td class="text-center">{{item.zscore}}</td>
                            <td class="text-center">{{item.zgrade}}</td>
                        </tr>
                    </tbody>
                </table>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {   
            headers : [
                this.i18n("QBR.Factory"),this.i18n("QBR.Date"),this.i18n("QBR.Vendor"),this.i18n("QBR.ClassificationCode"),this.i18n("QBR.QBRGrade"),
                this.i18n("QBR.ZvenCooperationP"),this.i18n("QBR.DefectRate"),this.i18n("QBR.ISSUEQuantity"),this.i18n("QBR.ZvenIssueP"),this.i18n("QBR.ZplmTrialP"),
                this.i18n("QBR.Technology"),this.i18n("QBR.SampleLeadTime"),this.i18n("QBR.SystemConfirmationRate"),this.i18n("QBR.MaterialYield"),this.i18n("QBR.OnTimeDelivery"),
                this.i18n("QBR.Service"),this.i18n("QBR.TotalScore"),this.i18n("QBR.QBRRanking")
            ],
            qbrQueryParam: {
                factoryId:'',
                hadQuery : false,
                customerName: '' , 
                createDateBegin: null, 
                createDateEnd: null},
            qbrSearchResult: [],
            factoryList: this.$t('factoryQMList'), //廠別 清單
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.headers = [
                this.i18n("QBR.Factory"),this.i18n("QBR.Date"),this.i18n("QBR.Vendor"),this.i18n("QBR.ClassificationCode"),this.i18n("QBR.QBRGrade"),
                this.i18n("QBR.ZvenCooperationP"),this.i18n("QBR.DefectRate"),this.i18n("QBR.ISSUEQuantity"),this.i18n("QBR.ZvenIssueP"),this.i18n("QBR.ZplmTrialP"),
                this.i18n("QBR.Technology"),this.i18n("QBR.SampleLeadTime"),this.i18n("QBR.SystemConfirmationRate"),this.i18n("QBR.MaterialYield"),this.i18n("QBR.OnTimeDelivery"),
                this.i18n("QBR.Service"),this.i18n("QBR.TotalScore"),this.i18n("QBR.QBRRanking")
            ]
            this.factoryList = this.$t('factoryQMList') //廠別 清單
        }
    },
    methods: {
        checkSearchParam(){ //檢核條件

        },
        qbrQueryEvent (){
            this.checkSearchParam();
            this.qbrQueryParam.hadQuery = true;
            this.doQbrSearch (this.qbrQueryParam);                
        },
        doQbrSearch (param){
            const url = `${this.$apiUrl_Quality}/SearchQBR`;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    this.qbrSearchResult = response.data;
                    this.setCacheQueryParam('QBP_QueryParam' , param);                           
                }                    
            }); 
        },
        qbrExportEvent (){ //匯出
            this.doQbrExport(this.qbrQueryParam);
        },
        doQbrExport (param){
            const url = `${this.$apiUrl_Quality}/PrepareSearchQBRExport`;
            this.axios.post(url, param).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Quality}/SearchQBRExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('qbrExportExcel',urlExcel);
            })
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"]),
        disableFactory (){
            if(this.isMember){
                return true;
            }
            return false;
        } 
    },
	mounted() {     
        this.getCacheQueryParam('QBP_QueryParam' , this.qbrQueryParam);   
        if(this.isMember){
            const userInfo = this.$userInfo ;
            this.qbrQueryParam.vendorId = userInfo.vendorId;
            this.qbrQueryParam.customerName = userInfo.companyName;                     
        }else{
            this.initMemberQMList();     
        }
        if(this.qbrQueryParam.hadQuery){
            this.qbrQueryEvent ()
        }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .name, .factory, .supplier, .watch, .check, .status, .date {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        // width: 350px;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            flex: 1;
            margin: 0 .5rem;
        }
        > div {
             margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table th {
    background-color: #303c50;
    color: #fff;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
.table tr.table-close {
    background-color: #D0D0D0;
}

.scroll {
  overflow-x: scroll;
}

</style>




